import { NgModule } from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';

import { AuthFormPageComponent } from './containers/auth-form-page/auth-form-page.component';
import { AuthSsoFormPageComponent } from './containers/auth-sso-form-page/auth-sso-form-page.component';
import { AuthSignupFormPageComponent } from './containers/auth-signup-form-page/auth-signup-form-page.component';

const routes: Routes = [
  {
    path: 'login',
    component: AuthFormPageComponent
  },
  {
    path: 'login-sso',
    component: AuthSsoFormPageComponent
  },
  {
    path: 'signup',
    component: AuthSignupFormPageComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AuthRoutingModule {}
